import React, { PureComponent } from 'react';
import * as api from '../../../../services/api';
import { bindActionCreators } from 'redux';
import actions from '../../../../actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as _ from 'lodash-es';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import CustomEmployeePage from '../../../presenters/admins/SelectBranchesPage/SelectBranchesPage';
import { injectIntl } from 'react-intl';

class SelectBranchesContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      branches: []
    };

    this.loadState = this.loadState.bind(this);
    this.onSelectBranch = this.onSelectBranch.bind(this);
    this.onClearBranches = this.onClearBranches.bind(this);
  }

  componentDidMount() {
    this.loadState();
  }

  loadState() {
    this.setState(
      {
        loading: true
      },
      () => {
        api.branches
          .get()
          .then((response) => {
            this.setState({
              branches: SelectBranchesContainer.mapBranches(
                response.data.content,
                this.props.appStore.branches.map((branch) => branch.branchId)
              ),
              loading: false
            });
          })
          .catch((err) => {
            console.error('error fetching branches: ', err.message);
            this.setState({
              loading: false
            });
          });
      }
    );
  }

  onSelectBranch(selectedBranch) {
    let branches = this.state.branches.map((branch) => {
      if (branch.branchName === selectedBranch.branchName) {
        branch.selected = !branch.selected;
      }
      return branch;
    });

    this.props.actions.setAdminsSelectedBranches(
      branches.filter((b) => b.selected)
    );

    this.setState({
      branches
    });
  }

  onClearBranches() {
    this.props.actions.setAdminsSelectedBranches([]);
    let unselectedBranches = this.state.branches.map((b) => ({
      ...b,
      selected: false
    }));

    this.setState({
      branches: unselectedBranches
    });
  }

  static mapBranches(branches, selectedBranches) {
    return branches.map((branch) => ({
      ...branch,
      selected: _.includes(selectedBranches, `${branch.branchId}`)
    }));
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <CustomEmployeePage
        selectableBranches={this.state.branches}
        onBranchSelected={this.onSelectBranch}
        onClearBranches={this.onClearBranches}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SelectBranchesContainer)
  )
);
